<div class="home-container">
  <app-header />
  <div class="home-body">
    <app-sidebar />

    <main class="home-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>